var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCause1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff305e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.08,15.39c-4.66-4.66-10.85-7.22-17.43-7.22s-12.77,2.56-17.43,7.22L15.15,50.47c-9.45,9.45-9.45,24.82,0,34.26,4.58,4.58,10.66,7.1,17.13,7.1s12.56-2.52,17.13-7.1l35.66-35.66c9.28-9.28,9.28-24.39,0-33.67ZM59.16,59.11c-.39.39-.9.59-1.41.59s-1.02-.2-1.41-.59l-15.56-15.56c-.78-.78-.78-2.05,0-2.83.78-.78,2.05-.78,2.83,0l15.56,15.56c.78.78.78,2.05,0,2.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause1);
export default __webpack_public_path__ + "static/media/cause_1.e5e8e5bd18a0d5b93b36004affacf0ec.svg";
export { ForwardRef as ReactComponent };